import { createContext, useContext } from 'react';

import { drawingShapeContextInitialValue } from './drawingShape.constants';
import { DrawingShapeContextType } from './drawingShape.types';

export const DrawingShapeContext = createContext<DrawingShapeContextType>(
  drawingShapeContextInitialValue
);

export const useDrawingShapeContext = () => {
  const context = useContext(DrawingShapeContext);

  if (!context) {
    throw new Error(
      'useDrawingShapeContext must be used within a DrawingShapeContextProvider'
    );
  }

  return context;
};
